import {useQuery} from "react-query";
import {KVPair, Meal, ServerError} from "../models/types";
import {retrieveMeals} from "../restapi/meal";


export function useRetrieveMeals({filters, sorting, onError}: { filters?: KVPair[], sorting?: string[], onError?: (e: ServerError) => void }): Meal[] | undefined {
    const mealQuery = useQuery(['Meals'], () => retrieveMeals(filters, sorting), {onError: onError});
    return mealQuery.data;
}
